import { guardExist as i, guardEmptyString as l, guardMaxLengthString as g } from "@smh/utils/guards";
const p = /<\/?[^>]+>/g, L = (t) => t.replace(/\r?\n/g, ""), T = (t) => t.charAt(0).toUpperCase() + t.slice(1), m = (t, e) => {
  const r = [2, 0, 1, 1, 1, 2];
  return e[t % 100 > 4 && t % 100 < 20 ? 2 : r[t % 10 < 5 ? t % 10 : 5]];
}, u = (t, e = p) => i(t) && l(t) ? t.replace(e, "") : "", x = (t) => {
  const {
    length: e,
    postfix: r = "",
    subject: c,
    removeLastWord: a = !1,
    removeHTML: n = !1
  } = t, s = n ? u(c) : c;
  if (g(s, e))
    return s;
  const o = s.slice(0, e);
  return a ? o.split(" ").slice(0, -1).join(" ") + r : o + r;
};
export {
  T as capitalize,
  m as plural,
  u as removeHtmlTags,
  L as removeLineBreaks,
  x as truncate
};
